import { render } from "./AboutUs.vue?vue&type=template&id=80380086&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=80380086&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80380086"]])

export default __exports__